import Config from './config.js'

let NavConfig = {
    SystemNav: [{
        moduleType: "Users",
        imgurl: require('../assets/images/system/users.png'),
        icon: 'icon-yonghuguanli',
        path: '/system/users',
        permission:['user'],
        name: '用户管理',
        sort: 1
    }, {
        moduleType: "Role",
        imgurl: require('../assets/images/system/role.png'),
        icon: 'icon-jiaoseguanli',
        path: '/system/role',
        permission:['role'],
        name: '角色管理',
        sort: 2
    }, {
        moduleType: "Authority",
        imgurl: require('../assets/images/system/authority.png'),
        icon: 'icon-quanxianguanli',
        path: '/system/authority',
        permission:['permission'],
        name: '权限管理',
        sort: 2
    },
        //  {
        //     moduleType: "Company",
        //     imgurl: require('../assets/images/system/company.png'),
        //     icon: 'icon-danweiguanli',
        //     path: '/system/company',
        //     name: '单位管理',
        //     sort: 3
        // },
        {
            moduleType: "Department",
            imgurl: require('../assets/images/system/department.png'),
            icon: 'icon-zhiduguanli',
            path: '/system/department',
            permission:['dept'],
            name: '部门管理',
            sort: 4
        },
        // {
        //     moduleType: "Staff",
        //     imgurl: require('../assets/images/system/staff.png'),
        //     icon: 'icon-yuangongguanli',
        //     path: '/system/staff',
        //     name: '员工管理',
        //     sort: 5
        // },
        {
            moduleType: "Loginlog",
            imgurl: require('../assets/images/system/loginlog.png'),
            icon: 'icon-denglurizhi',
            path: '/system/loginlog',
            name: '登录日志',
            sort: 6
        }, {
            moduleType: "Operatelog",
            imgurl: require('../assets/images/system/operatelog.png'),
            icon: 'icon-caozuorizhi',
            path: '/system/operatelog',
            name: '操作日志',
            sort: 7
        }, {
            moduleType: "Datadir",
            imgurl: require('../assets/images/system/datadir.png'),
            icon: 'icon-shujuzidian',
            // path: '/system/datadir',
            path: '/system/datadir',
            name: '数据字典',
            sort: 8
        }, {
            moduleType: "Grainmanagement",
            imgurl: require('../assets/images/system/datadir.png'),
            icon: 'icon-liangqingweihu',
            path: '/system/grainmanagement',
            name: '粮权维护',
            sort: 8
        }, {
            moduleType: "Examination",
            icon: 'icon-shenpiguanli',
            path: '/system/examination',
            name: '审批管理',
            sort: 9
        }, {
            moduleType: "Indicators",
            icon: 'icon-liangqingweihu',
            path: '/system/indicators',
            name: '指标管理',
            sort: 10
        },{
            moduleType: "Unitprice",
            path: '/system/unitprice',
            name: '单价设置',
            sort: 11
        }
    ],
    WorkTableNav: [{
        moduleType: "Working",
        imgurl: require('../assets/images/worktable/working.png'),
        icon: 'icon-gongzuotaishouye',
        path: '/worktable/working',
        name: '首页',
        sort: 1
    }, {
        moduleType: "Needdo",
        imgurl: require('../assets/images/worktable/needdo.png'),
        icon: 'icon-daiban',
        path: '/worktable/needdo',
        name: '待办事项',
        sort: 1,
        children: [
        {
            moduleType: "NeeddoJob",
            path: '/worktable/needdo/job',
            name: '日常作业',
            sort: 1,
            children: [
                {
                    moduleType: "NeeddoJobHighair",
                path: '/worktable/needdo/job/highair',
                name: '登高作业',
                sort: 1,
                }, {
                    moduleType: "NeeddoJobFire",
                    path: '/worktable/needdo/job/fire',
                    name: '动火作业',
                    sort: 1,
                }, {
                    moduleType: "NeeddoJobSoil",
                    path: '/worktable/needdo/job/soil',
                    name: '动土作业',
                    sort: 1,
                }, {
                    moduleType: "NeeddoJobCrane",
                    path: '/worktable/needdo/job/crane',
                    name: '吊装作业',
                    sort: 1,
                }, {
                    moduleType: "NeeddoJobCircuit",
                    path: '/worktable/needdo/job/circuit',
                    name: '断路作业',
                    sort: 1,
                }, {
                    moduleType: "NeeddoJobElectric",
                    path: '/worktable/needdo/job/electric',
                    name: '临时用电作业',
                    sort: 1,
                },  {
                    moduleType: "NeeddoJobSpace",
                    path: '/worktable/needdo/job/space',
                    name: '有限空间作业',
                    sort: 1,
                },
            ]
        },
        {
            moduleType: "NeeddoDevice",
            path: '/worktable/needdo/device',
            name: '设备管理',
            sort: 1,
            children: [{
                moduleType: "NeeddoDevicePurchase",
                path: '/worktable/needdo/device/purchase',
                name: '入库设备',
                sort: 1,
            }, {
                moduleType: "NeeddoDeviceClaim",
                path: '/worktable/needdo/device/claim',
                name: '领用设备',
                sort: 1,
            },
                // {
                //     moduleType: "NeeddoDeviceBack",
                //     path: '/worktable/needdo/device/back',
                //     name: '归还设备',
                //     sort: 1,
                // },
                {
                    moduleType: "NeeddoDeviceRepair",
                    path: '/worktable/needdo/device/repair',
                    name: '维修设备',
                    sort: 1,
                }, {
                    moduleType: "NeeddoDeviceScrap",
                    path: '/worktable/needdo/device/scrap',
                    name: '报废设备',
                    sort: 1,
                }]
        }, {
            moduleType: "NeeddoStoreapprove",
            path: '/worktable/needdo/storeapprove',
            name: '仓库作业',
            sort: 1,
            children: [{
                moduleType: "NeeddoStoreapproveLossover",
                path: '/worktable/needdo/storeapprove/lossover',
                name: '损溢管理',
                sort: 1,
            },
                // {
                //     moduleType: "NeeddoStoreapproveQualityreport",
                //     path: '/worktable/needdo/storeapprove/qualityreport',
                //     name: '质检报告',
                //     sort: 1,
                // },
                {
                    moduleType: "NeeddoStoreapproveDumpthestock",
                    path: '/worktable/needdo/storeapprove/dumpthestock',
                    name: '倒仓管理',
                    sort: 1,
                }
            ]
        },
            // {
            //     moduleType: "NeeddoNotice",
            //     path: '/worktable/notices',
            //     name: '通知单',
            //     sort: 1,
            //     children: [{
            //         moduleType: "NeeddoNoticesInstore",
            //         path: '/worktable/needdo/notices/instore',
            //         name: '入库单',
            //         sort: 1,
            //     },
            //         {
            //             moduleType: "NeeddoNoticesOutstore",
            //             path: '/worktable/needdo/notices/outstore',
            //             name: '提货单',
            //             sort: 1,
            //         },
            //         // {
            //         //     moduleType: "NeeddoNoticesMovestore",
            //         //     path: '/worktable/needdo/notices/movestore',
            //         //     name: '移库申请单',
            //         //     sort: 1,
            //         // }
            //     ]
            // },
            {
                moduleType: "NeeddoSafetask",
                path: '/worktable/needdo/safetask',
                name: '安全检查',
                sort: 1,
            }, {
                moduleType: "NeeddoGraintask",
                path: '/worktable/needdo/graintask',
                name: '粮情检查',
                sort: 1,
            }
        ]
    }, {
        moduleType: "Issueditems",
        imgurl: require('../assets/images/worktable/issueditems.png'),
        icon: 'icon-yifa',
        path: '/worktable/issueditems',
        name: '我的申请',
        sort: 1,
        children: [
            {
                moduleType: "IssueditemsJob",
                path: '/worktable/issueditems/job',
                name: '日常作业',
                sort: 1,
                children: [
                    {
                        moduleType: "IssueditemsJobHighair",
                    path: '/worktable/issueditems/job/highair',
                    name: '登高作业',
                    sort: 1,
                    }, {
                        moduleType: "IssueditemsJobFire",
                        path: '/worktable/issueditems/job/fire',
                        name: '动火作业',
                        sort: 1,
                    }, {
                        moduleType: "IssueditemsJobSoil",
                        path: '/worktable/issueditems/job/soil',
                        name: '动土作业',
                        sort: 1,
                    }, {
                        moduleType: "IssueditemsJobCrane",
                        path: '/worktable/issueditems/job/crane',
                        name: '吊装作业',
                        sort: 1,
                    }, {
                        moduleType: "IssueditemsJobCircuit",
                        path: '/worktable/issueditems/job/circuit',
                        name: '断路作业',
                        sort: 1,
                    }, {
                        moduleType: "IssueditemsJobElectric",
                        path: '/worktable/issueditems/job/electric',
                        name: '临时用电作业',
                        sort: 1,
                    },  {
                        moduleType: "IssueditemsJobSpace",
                        path: '/worktable/issueditems/job/space',
                        name: '有限空间作业',
                        sort: 1,
                    },
                ]
            },{
            moduleType: "IssueditemsDevice",
            path: '/worktable/issueditems/device',
            name: '设备管理',
            sort: 1,
            children: [{
                moduleType: "IssueditemsDevicePurchase",
                path: '/worktable/issueditems/device/purchase',
                name: '入库设备',
                sort: 1,
            }, {
                moduleType: "IssueditemsDeviceClaim",
                path: '/worktable/issueditems/device/claim',
                name: '领用设备',
                sort: 1,
            },
                // {
                //     moduleType: "IssueditemsDeviceBack",
                //     path: '/worktable/issueditems/device/back',
                //     name: '归还设备',
                //     sort: 1,
                // },
                {
                    moduleType: "IssueditemsDeviceRepair",
                    path: '/worktable/issueditems/device/repair',
                    name: '维修设备',
                    sort: 1,
                }, {
                    moduleType: "IssueditemsDeviceScrap",
                    path: '/worktable/issueditems/device/scrap',
                    name: '报废设备',
                    sort: 1,
                }]
        }, {
            moduleType: "IssueditemsStoreapprove",
            path: '/worktable/issueditems/storeapprove',
            name: '仓库作业',
            sort: 1,
            children: [{
                moduleType: "IssueditemsStoreapproveLossover",
                path: '/worktable/issueditems/storeapprove/lossover',
                name: '损溢管理',
                sort: 1,
            },
                // {
                //     moduleType: "IssueditemsStoreapproveQualityreport",
                //     path: '/worktable/issueditems/storeapprove/qualityreport',
                //     name: '质检报告',
                //     sort: 1,
                // },
                {
                    moduleType: "IssueditemsStoreapproveDumpthestock",
                    path: '/worktable/issueditems/storeapprove/dumpthestock',
                    name: '倒仓管理',
                    sort: 1,
                }
            ]
        },
            {
                moduleType: "IssueditemsNotices",
                path: '/worktable/issueditems/notices',
                name: '通知单',
                sort: 1,
                children: [{
                    moduleType: "IssueditemsNoticesInstore",
                    path: '/worktable/issueditems/notices/instore',
                    name: '入库单',
                    sort: 1,
                },
                    {
                        moduleType: "IssueditemsNoticesOutstore",
                        path: '/worktable/issueditems/notices/outstore',
                        name: '提货单',
                        sort: 1,
                    },
                    // {
                    //     moduleType: "IssueditemsNoticesMovestore",
                    //     path: '/worktable/issueditems/notices/movestore',
                    //     name: '移库申请单',
                    //     sort: 1,
                    // }
                ]
            },
            // {
            //     moduleType: "IssueditemsSafetask",
            //     path: '/worktable/issueditems/safetask',
            //     name: '安全检查',
            //     sort: 1,
            // },
            // {
            //     moduleType: "IssueditemsGraintask",
            //     path: '/worktable/issueditems/graintask',
            //     name: '粮情检查',
            //     sort: 1,
            // }
        ]
    },
        {
            moduleType: "Workdone",
            imgurl: require('../assets/images/worktable/wordone.png'),
            icon: 'icon-yiban',
            path: '/worktable/workdone',
            name: '我的审批',
            sort: 1,
            children: [{
                moduleType: "WorkdoneJob",
                path: '/worktable/workdone/job',
                name: '日常作业',
                sort: 1,
                children: [
                    {
                        moduleType: "WorkdoneJobHighair",
                    path: '/worktable/workdone/job/highair',
                    name: '登高作业',
                    sort: 1,
                    }, {
                        moduleType: "WorkdoneJobFire",
                        path: '/worktable/workdone/job/fire',
                        name: '动火作业',
                        sort: 1,
                    }, {
                        moduleType: "WorkdoneJobSoil",
                        path: '/worktable/workdone/job/soil',
                        name: '动土作业',
                        sort: 1,
                    }, {
                        moduleType: "WorkdoneJobCrane",
                        path: '/worktable/workdone/job/crane',
                        name: '吊装作业',
                        sort: 1,
                    }, {
                        moduleType: "WorkdoneJobCircuit",
                        path: '/worktable/workdone/job/circuit',
                        name: '断路作业',
                        sort: 1,
                    }, {
                        moduleType: "WorkdoneJobElectric",
                        path: '/worktable/workdone/job/electric',
                        name: '临时用电作业',
                        sort: 1,
                    },  {
                        moduleType: "WorkdoneJobSpace",
                        path: '/worktable/workdone/job/space',
                        name: '有限空间作业',
                        sort: 1,
                    },
                ]
            }, {
                moduleType: "WorkdoneDevice",
                path: '/worktable/workdone/device',
                name: '设备管理',
                sort: 1,
                children: [{
                    moduleType: "WorkdoneDevicePurchase",
                    path: '/worktable/workdone/device/purchase',
                    name: '入库设备',
                    sort: 1,
                }, {
                    moduleType: "WorkdoneDeviceClaim",
                    path: '/worktable/workdone/device/claim',
                    name: '领用设备',
                    sort: 1,
                },
                    // {
                    //     moduleType: "WorkdoneDeviceBack",
                    //     path: '/worktable/workdone/device/back',
                    //     name: '归还设备',
                    //     sort: 1,
                    // },
                    {
                        moduleType: "WorkdoneDeviceRepair",
                        path: '/worktable/workdone/device/repair',
                        name: '维修设备',
                        sort: 1,
                    }, {
                        moduleType: "WorkdoneDeviceScrap",
                        path: '/worktable/workdone/device/scrap',
                        name: '报废设备',
                        sort: 1,
                    }]
            }, {
                moduleType: "WorkdoneStoreapprove",
                path: '/worktable/workdone/storeapprove',
                name: '仓库作业',
                sort: 1,
                children: [{
                    moduleType: "WorkdoneStoreapproveLossover",
                    path: '/worktable/workdone/storeapprove/lossover',
                    name: '损溢管理',
                    sort: 1,
                },
                    // {
                    //     moduleType: "WorkdoneStoreapproveQualityreport",
                    //     path: '/worktable/workdone/storeapprove/qualityreport',
                    //     name: '质检报告',
                    //     sort: 1,
                    // },
                    {
                        moduleType: "WorkdoneStoreapproveDumpthestock",
                        path: '/worktable/workdone/storeapprove/dumpthestock',
                        name: '倒仓管理',
                        sort: 1,
                    }
                ]
            },
                // {
                //     moduleType: "WorkdoneNotices",
                //     path: '/worktable/workdone/notices',
                //     name: '通知单',
                //     sort: 1,
                //     children: [{
                //         moduleType: "WorkdoneNoticesInstore",
                //         path: '/worktable/workdone/notices/instore',
                //         name: '入库单',
                //         sort: 1,
                //     },
                //         {
                //             moduleType: "WorkdoneNoticesOutstore",
                //             path: '/worktable/workdone/notices/outstore',
                //             name: '提货单',
                //             sort: 1,
                //         },
                //         {
                //             moduleType: "WorkdoneNoticesMovestore",
                //             path: '/worktable/workdone/notices/movestore',
                //             name: '移库申请单',
                //             sort: 1,
                //         }
                //     ]
                // },
                // {
                //     moduleType: "WorkdoneSafetask",
                //     path: '/worktable/workdone/safetask',
                //     name: '安全检查',
                //     sort: 1,
                // }, {
                //     moduleType: "WorkdoneGraintask",
                //     path: '/worktable/workdone/graintask',
                //     name: '粮情检查',
                //     sort: 1,
                // }
            ]
        }, {
            moduleType: "Applyitems",
            imgurl: require('../assets/images/worktable/applyitems.png'),
            icon: 'icon-shenqing',
            path: '/worktable/applyitems',
            name: '快速办理',
            sort: 1,
            children: [{
                moduleType: "ApplyitemsDaily",
                path: '/worktable/applyitems/daily',
                name: '日常作业',
                sort: 1,
            }, {
                moduleType: "ApplyitemsDevice",
                path: '/worktable/applyitems/device',
                name: '设备管理',
                sort: 1,
                children: [{
                    moduleType: "ApplyitemsDevicePurchase",
                    path: '/worktable/applyitems/device/purchase',
                    name: '入库设备',
                    sort: 1,
                }, {
                    moduleType: "ApplyitemsDeviceClaim",
                    path: '/worktable/applyitems/device/claim',
                    name: '领用设备',
                    sort: 1,
                },
                    // {
                    //     moduleType: "ApplyitemsDeviceBack",
                    //     path: '/worktable/applyitems/device/back',
                    //     name: '归还设备',
                    //     sort: 1,
                    // },
                    {
                        moduleType: "ApplyitemsDeviceRepair",
                        path: '/worktable/applyitems/device/repair',
                        name: '维修设备',
                        sort: 1,
                    }, {
                        moduleType: "ApplyitemsDeviceScrap",
                        path: '/worktable/applyitems/device/scrap',
                        name: '报废设备',
                        sort: 1,
                    }]
            }, {
                moduleType: "ApplyitemsStore",
                path: '/worktable/applyitems/storeapprove',
                name: '仓库作业',
                sort: 1,
                children: [{
                    moduleType: "ApplyitemsStoreapproveLossover",
                    path: '/worktable/applyitems/storeapprove/lossover',
                    name: '损溢管理',
                    sort: 1,
                },
                    // {
                    //     moduleType: "ApplyitemsStoreapproveQualityreport",
                    //     path: '/worktable/applyitems/storeapprove/qualityreport',
                    //     name: '质检报告',
                    //     sort: 1,
                    // },
                    {
                        moduleType: "ApplyitemsStoreapproveDumpthestock",
                        path: '/worktable/applyitems/storeapprove/dumpthestock',
                        name: '倒仓管理',
                        sort: 1,
                    }
                ]
            }, 
            // {
            //     moduleType: "ApplyitemsNotices",
            //     path: '/worktable/applyitems/notices',
            //     name: '通知单',
            //     sort: 1,
            //     children: [{
            //         moduleType: "ApplyitemsNoticesInstore",
            //         path: '/worktable/applyitems/notices/instore',
            //         name: '入库单',
            //         sort: 1,
            //     },
            //         {
            //             moduleType: "ApplyitemsNoticesOutstore",
            //             path: '/worktable/applyitems/notices/outstore',
            //             name: '提货单',
            //             sort: 1,
            //         },
            //         // {
            //         //     moduleType: "ApplyitemsNoticesMovestore",
            //         //     path: '/worktable/applyitems/notices/movestore',
            //         //     name: '移库申请单',
            //         //     sort: 1,
            //         // }
            //     ]
            // }
        ]
        }, {
            moduleType: "Worknotice",
            imgurl: require('../assets/images/worktable/worknotice.png'),
            icon: 'icon-gaojing',
            path: '/worktable/worknotice',
            name: '消息通知',
            sort: 1,
            children: [
                //     {
                //     moduleType: "WorknoticeNotice",
                //     path: '/worktable/worknotice/notice',
                //     name: '通知单',
                //     sort: 1,
                // },
                {
                    moduleType: "WorknoticeGrain",
                    path: '/worktable/worknotice/grain',
                    name: '粮情告警信息',
                    sort: 1,
                }, {
                    // moduleType: "WorknoticeStore",
                    // path: '/worktable/worknotice/store',
                    // name: '出入库信息',
                    // sort: 1,
                    // }, {
                    moduleType: "WorknoticeSysinfo",
                    path: '/worktable/worknotice/sysinfo',
                    name: '通知公告',
                    sort: 1,
                }]
        }],
    StatisticsNav: [{
        moduleType: "Information",
        imgurl: require('../assets/images/statistics/information.png'),
        icon: 'icon-cangchuxinxizhanshi',
        path: '/statistics/information',
        name: '仓储信息展示',
        sort: 1
    }, {
        moduleType: "Business",
        imgurl: require('../assets/images/statistics/business.png'),
        icon: 'icon-cangchuyewuguanli',
        path: '/statistics/business',
        name: '仓储业务管理',
        sort: 1,
        children: [
            //     {
            //     moduleType: "BusinessCar",
            //     path: '/statistics/business/car',
            //     name: '车辆登记列表',
            //     sort: 1,
            // },
            {
                moduleType: "BusinessRegistration",
                path: '/statistics/business/registration',
                name: '登记记录',
                sort: 1,
            }, {
                moduleType: "BusinessAssay",
                path: '/statistics/business/assay',
                name: '化验列表',
                sort: 1,
            }, {
                moduleType: "BusinessWeight",
                path: '/statistics/business/weight',
                name: '称重列表',
                sort: 1,
            },
            {
                moduleType: "BusinessBack",
                path: '/statistics/business/back',
                name: '退车记录',
                sort: 1,
            },
            {
                moduleType: "BusinessSettlement",
                path: '/statistics/business/settlement',
                name: '结算记录',
                sort: 1,
            }, {
                moduleType: "ReportInout",
                path: '/statistics/report/inout',
                name: '出入库报表',
                sort: 1,
            }]
    }, {
        moduleType: "Infos",
        imgurl: require('../assets/images/statistics/infos.png'),
        icon: 'icon-cangchuxinxiguanli',
        path: '/statistics/infos',
        name: '仓储信息管理',
        sort: 1,
        children: [
            {
                moduleType: "InfosRecord",
                path: '/statistics/infos/record',
                name: '出入库记录',
                sort: 1,
            },
            {
                moduleType: "InfosStore",
                path: '/statistics/infos/store',
                name: '库存信息',
                sort: 1,
            },
            {
                moduleType: "InfosGeneralledger",
                path: '/statistics/infos/generalledger',
                name: '保管总账',
                sort: 1,
            },
            {
                moduleType: "InfosDivideaccount",
                path: '/statistics/infos/divideaccount',
                name: '保管分仓账',
                sort: 1,
            }
            // , {
            //     moduleType: "InfosInspeed",
            //     path: '/statistics/infos/inspeed',
            //     name: '入库进度表',
            //     sort: 1,
            // }, {
            //     moduleType: "InfosOutspeed",
            //     path: '/statistics/infos/outspeed',
            //     name: '出库进度表',
            //     sort: 1,
            // }, {
            //     moduleType: "InfosScheduletransfer",
            //     path: '/statistics/infos/scheduletransfer',
            //     name: '移库进度表',
            //     sort: 1,
            // }, {
            //     moduleType: "InfosSchedulebarn",
            //     path: '/statistics/infos/schedulebarn',
            //     name: '倒仓进度表',
            //     sort: 1,
            // }
            // , {
            //     moduleType: "InfosStoreassay",
            //     path: '/statistics/infos/storeassay',
            //     name: '库存化验',
            //     sort: 1,
            // }
        ]
    },
        //     {
        //     moduleType: "Report",
        //     imgurl: require('../assets/images/statistics/report.png'),
        //     icon: 'icon-cangchubaobiaoguanli',
        //     path: '/statistics/report',
        //     name: '仓储报表管理',
        //     sort: 1,
        //     children: [
        //
        //         {
        //         moduleType: "ReportStore",
        //         path: '/statistics/report/store',
        //         name: '库存报表',
        //         sort: 1,
        //     }
        //     ]
        // }
    ],
    ManageNav: [{
        moduleType: "Basics",
        imgurl: require('../assets/images/manage/basics.png'),
        icon: 'icon-jichuxinxiguanli',
        path: '/manage/basics ',
        name: '基础信息管理',
        sort: 1,
        children: [{
            moduleType: "BasicsBarn",
            path: '/manage/basics/barn',
            name: '仓房管理',
            sort: 1,
        }, 
        {
            moduleType: "BasicsPound",
            // imgurl: require('../assets/images/manage/basics.png'),
            // icon: 'icon-jichuxinxiguanli',
            path: '/manage/basics/pound ',
            name: '磅房管理',
            sort: 1,
            children:[
                {
                    moduleType: "BasicsPound",
                    path: '/manage/basics/pound',
                    name: '磅房管理',
                    sort: 1,
                }, {
                    moduleType: "BasicsCameras",
                    path: '/manage/basics/cameras',
                    name: '摄像头管理',
                    sort: 1,
                },
            ]
        },
        {
            moduleType: "BasicsGranary",
            path: '/manage/basics/granary',
            name: '货位管理',
            sort: 1,
        },{
            moduleType: "BasicsCustomer",
            path: '/manage/basics/customer',
            name: '客户信息',
            sort: 1,
        },{
            moduleType: "BasicsContract",
            path: '/manage/basics/contract',
            name: '合同信息',
            sort: 1,
        },{
            moduleType: "BasicsChange",
            path: '/manage/basics/change',
            name: '性质转换信息',
            sort: 1,
        },{
            moduleType: "BasicsErrorchangeList",
            path: '/manage/basics/errorchange/list',
            name: '错误数据修改信息',
            sort: 1,
        }]
    }, {
        moduleType: "Graincheck",
        imgurl: require('../assets/images/manage/graincheck.png'),
        icon: 'icon-liangqingjiancha',
        path: '/manage/graincheck',
        name: '粮情检查',
        sort: 1,
        children: [{
            moduleType: "GraincheckTask",
            path: '/manage/graincheck/task',
            name: '粮情检查任务',
            sort: 1,
        }, {
            moduleType: "GraincheckList",
            path: '/manage/graincheck/list',
            name: '粮情检查记录',
            sort: 1,
        }, {
            moduleType: "GraincheckMeeting",
            path: '/manage/graincheck/meeting',
            name: '会议纪要',
            sort: 1,
        }]
    },
        // {
        //     moduleType: "Approve",
        //     imgurl: require('../assets/images/manage/approve.png'),
        //     path: '/manage/approve',
        //     name: '审批管理',
        //     sort: 1,
        //     children: [{
        //         moduleType: "ApproveApply",
        //         path: '/manage/approve/apply',
        //         name: '发起申请',
        //         sort: 1,
        //     }, {
        //         moduleType: "ApproveMine",
        //         path: '/manage/approve/mine',
        //         name: '我的审批',
        //         sort: 1,
        //     }, {
        //         moduleType: "ApproveCommitted",
        //         path: '/manage/approve/committed',
        //         name: '我已提交',
        //         sort: 1,
        //     }, {
        //         moduleType: "ApproveRecord",
        //         path: '/manage/approve/record',
        //         name: '审批记录',
        //         sort: 1,
        //     }]
        // },
        {
            moduleType: "Equipment",
            imgurl: require('../assets/images/manage/equipment.png'),
            icon: 'icon-shebeiguanli',
            path: '/manage/equipment',
            name: '设备管理',
            sort: 1,
            children: [{
                moduleType: "EquipmentPurchase",
                path: '/manage/equipment/purchase',
                name: '设备入库',
                sort: 1,
            }, {
                moduleType: "EquipmentClaim",
                path: '/manage/equipment/claim',
                name: '设备领用',
                sort: 1,
            },
                // {
                //     moduleType: "EquipmentBack",
                //     path: '/manage/equipment/back',
                //     name: '归还记录',
                //     sort: 1,
                // },
                {
                    moduleType: "EquipmentRepair",
                    path: '/manage/equipment/repair',
                    name: '维修记录',
                    sort: 1,
                }, {
                    moduleType: "EquipmentScrap",
                    path: '/manage/equipment/scrap',
                    name: '报废记录',
                    sort: 1,
                }, {
                    moduleType: "EquipmentInventory",
                    path: '/manage/equipment/inventory',
                    name: '设备库存',
                    sort: 1,
                }
                // , {
                //     moduleType: "EquipmentQuery",
                //     path: '/manage/equipment/query',
                //     name: '设备查询统计',
                //     sort: 1,
                // }
            ]
        }, 
        // {
        //     moduleType: "Plan",
        //     imgurl: require('../assets/images/manage/plan.png'),
        //     icon: 'icon-jihuaguanli',
        //     path: '/manage/plan',
        //     name: '计划管理',
        //     sort: 1,
        //     children: [
        //         {
        //             moduleType: "PlanProgramme",
        //             path: '/manage/plan/programme',
        //             name: '轮换计划',
        //             sort: 1,
        //             children: [{
        //                 moduleType: "PlanProgrammeFormulate",
        //                 path: '/manage/plan/programme/formulate',
        //                 name: '制定轮换计划',
        //                 sort: 1,
        //             }, {
        //                 moduleType: "PlanProgrammeYear",
        //                 path: '/manage/plan/programme/year',
        //                 name: '年度轮换计划',
        //                 sort: 1,
        //             }, {
        //                 moduleType: "PlanProgrammeDetailed",
        //                 path: '/manage/plan/programme/detailed',
        //                 name: '轮换计划明细',
        //                 sort: 1,
        //             }]
        //         }, {
        //             moduleType: "PlanScheme",
        //             path: '/manage/plan/scheme',
        //             name: '轮换方案',
        //             sort: 1,
        //             children: [
        //                 //     {
        //                 //     moduleType: "PlanSchemeTotal",
        //                 //     path: '/manage/plan/scheme/total',
        //                 //     name: '总轮换方案',
        //                 //     sort: 1,
        //                 // },
        //                 {
        //                     moduleType: "PlanSchemeAddout",
        //                     path: '/manage/plan/scheme/addout',
        //                     name: '制定轮出方案',
        //                     sort: 1,
        //                 },
        //                 {
        //                     moduleType: "PlanSchemeAddin",
        //                     path: '/manage/plan/scheme/addin',
        //                     name: '制定轮入方案',
        //                     sort: 1,
        //                 }
        //             ]
        //         },
        //         //     {
        //         //     moduleType: "PlanProgramme",
        //         //     path: '/manage/plan/programme',
        //         //     name: '轮换计划',
        //         //     sort: 1,
        //         //     children: [{
        //         //         moduleType: "PlanProgrammeYear",
        //         //         path: '/manage/plan/programme/year',
        //         //         name: '年度轮换计划',
        //         //         sort: 1,
        //         //     }, {
        //         //         moduleType: "PlanProgrammeDetailed",
        //         //         path: '/manage/plan/programme/detailed',
        //         //         name: '轮换计划明细',
        //         //         sort: 1,
        //         //     }]
        //         // },
        //         {
        //             moduleType: "PlanNotice",
        //             path: '/manage/plan/notice',
        //             name: '通知单管理',
        //             sort: 1,
        //             children: [{
        //                 moduleType: "PlanNoticeOutstore",
        //                 path: '/manage/plan/notice/outstore',
        //                 name: '出库通知单',
        //                 sort: 1,
        //             }, {
        //                 moduleType: "PlanNoticeInstore",
        //                 path: '/manage/plan/notice/instore',
        //                 name: '入库通知单',
        //                 sort: 1,
        //             }]
        //         },
        //         // {
        //         //     moduleType: "PlanSpeed",
        //         //     path: '/manage/plan/speed',
        //         //     name: '轮换进度',
        //         //     sort: 1,
        //         //     children: [{
        //         //         moduleType: "PlanSpeedOutput",
        //         //         path: '/manage/plan/speed/output',
        //         //         name: '轮出进度报表',
        //         //         sort: 1,
        //         //     }, {
        //         //         moduleType: "PlanSpeedInput",
        //         //         path: '/manage/plan/speed/input',
        //         //         name: '轮入进度报表',
        //         //         sort: 1,
        //         //     }]
        //         // }
        //     ]
        // }, 
        {
            moduleType: "Safe",
            imgurl: require('../assets/images/manage/safe.png'),
            icon: 'icon-anquanguanli',
            path: '/manage/safe',
            name: '安全管理',
            sort: 1,
            children: [{
                moduleType: "SafeDutybook",
                path: '/manage/safe/dutybook',
                name: '责任书',
                sort: 1,
            }, {
                moduleType: "SafeCheck",
                path: '/manage/safe/check',
                name: '安全检查',
                sort: 1,
                children: [{
                    moduleType: "SafeCheckCheck",
                    path: '/manage/safe/check/check',
                    name: '安全检查通知',
                    sort: 1,
                }, {
                    moduleType: "SafeCheckRecord",
                    path: '/manage/safe/check/record',
                    name: '安全检查记录',
                    sort: 1,
                },
                ]
            }, {
                moduleType: "SafeSetype",
                path: '/manage/safe/setype',
                name: '值班管理',
                sort: 1,
            }, {
                moduleType: "SafeArchives",
                path: '/manage/safe/archives',
                name: '安全档案管理',
                sort: 1,
            }]
        }, {
            moduleType: "Rules",
            imgurl: require('../assets/images/manage/rules.png'),
            icon: 'icon-zhiduguanli',
            path: '/manage/rules',
            name: '制度管理',
            sort: 1,
            children: [{
                moduleType: "RulesSys",
                path: '/manage/rules/sys',
                name: '制度管理',
                sort: 1,
            }]
        }, {
            moduleType: "Rectify",
            imgurl: require('../assets/images/manage/rectify.png'),
            icon: 'icon-jianchazhenggaifankui',
            path: '/manage/rectify',
            name: '检查整改反馈',
            sort: 1,
            children: [{
                moduleType: "RectifyIssue",
                path: '/manage/rectify/issue',
                name: '整改通知书',
                sort: 2,
            },
                // {
                //     moduleType: "RectifyFeedback",
                //     path: '/manage/rectify/feedback',
                //     name: '整改记录',
                //     sort: 1,
                // },
                // {
                //     moduleType: "RectifyFeedall",
                //     path: '/manage/rectify/feedall',
                //     name: '整改记录汇总',
                //     sort: 1,
                // }
            ]
        }, 
        // {
        //     moduleType: "Notices",
        //     imgurl: require('../assets/images/manage/notices.png'),
        //     icon: 'icon-tongzhidanguanli',
        //     path: '/manage/notices',
        //     name: '通知单管理',
        //     sort: 1,
        //     children: [{
        //         moduleType: "NoticesInstore",
        //         path: '/manage/notices/instore',
        //         name: '入库单',
        //         sort: 2,
        //     }, {
        //         moduleType: "NoticesOutstore",
        //         path: '/manage/notices/outstore',
        //         name: '提货单',
        //         sort: 1,
        //     }, {
        //         moduleType: "NoticesMovestore",
        //         path: '/manage/notices/movestore',
        //         name: '移库申请单',
        //         sort: 1,
        //     }]
        // },
        // {
        //     moduleType: "Stockuphold",
        //     imgurl: require('../assets/images/manage/stockuphold.png'),
        //     icon: 'icon-kucunweihu',
        //     path: '/manage/stockuphold',
        //     name: '库存维护',
        //     sort: 1,
        //     children: [{
        //         moduleType: "StockupholdQuery",
        //         path: '/manage/stockuphold/query',
        //         name: '库存查询',
        //         sort: 1,
        //     }
        //     // , {
        //     //     moduleType: "StockupholdSup",
        //     //     path: '/manage/stockuphold/sup',
        //     //     name: '库存管理',
        //     //     sort: 1,
        //     // },
        //         // {
        //         //     moduleType: "StockupholdRecord",
        //         //     path: '/manage/stockuphold/record',
        //         //     name: '维护记录',
        //         //     sort: 1,
        //         // }
        //     ]
        // },
        {
            moduleType: "Lossover",
            imgurl: require('../assets/images/manage/lossover.png'),
            icon: 'icon-sunyiguanli',
            path: '/manage/lossover',
            name: '损溢管理',
            sort: 1,
            children: [
                // {
                //     moduleType: "LossoverApply",
                //     path: '/manage/lossover/apply',
                //     name: '损溢申请',
                //     sort: 1,
                // },
                {
                    moduleType: "LossoverList",
                    path: '/manage/lossover/list',
                    name: '损溢记录',
                    sort: 1,
                }]
        }, 
        // {
        //     moduleType: "Shift",
        //     imgurl: require('../assets/images/manage/lossover.png'),
        //     icon: 'icon-daocang',
        //     path: '/manage/shift',
        //     name: '倒仓管理',
        //     sort: 1,
        //     children: [{
        //         moduleType: "ShiftReplace",
        //         path: '/manage/shift/replace',
        //         name: '倒仓记录',
        //         sort: 1,
        //     }]
        // }, 
        {
            moduleType: "Job",
            imgurl: require('../assets/images/manage/job.png'),
            icon: 'icon-zuoyeguanli',
            path: '/manage/job',
            name: '作业管理',
            sort: 1,
            children: [{
                moduleType: "JobHighair",
                path: '/manage/job/highair',
                name: '登高作业',
                sort: 1,
            }, {
                moduleType: "JobFire",
                path: '/manage/job/fire',
                name: '动火作业',
                sort: 1,
            }, {
                moduleType: "JobSoil",
                path: '/manage/job/soil',
                name: '动土作业',
                sort: 1,
            }, {
                moduleType: "JobCrane",
                path: '/manage/job/crane',
                name: '吊装作业',
                sort: 1,
            }, {
                moduleType: "JobCircuit",
                path: '/manage/job/circuit',
                name: '断路作业',
                sort: 1,
            }, {
                moduleType: "JobElectric",
                path: '/manage/job/electric',
                name: '临时用电作业',
                sort: 1,
            },  {
                moduleType: "JobSpace",
                path: '/manage/job/space',
                name: '有限空间作业',
                sort: 1,
            },]
        }],
    QualityNav: [{
        moduleType: "Report",
        imgurl: require('../assets/images/quality/report.png'),
        icon: 'icon-jianyanbaogao',
        path: '/quality/report',
        name: '质检报告',
        sort: 1,
    }, {
        moduleType: "Barncard",
        imgurl: require('../assets/images/quality/barncard.png'),
        icon: 'icon-cangfanghuoweika',
        path: '/quality/barncard',
        name: '仓房货位卡',
        sort: 1,
        children: [{
            moduleType: "BarncardNew",
            path: '/quality/barncard/new',
            name: '当前货位卡',
            sort: 1,
        }, {
            moduleType: "BarncardOld",
            path: '/quality/barncard/old',
            name: '历史货位卡',
            sort: 1,
        },]
    }, {
        moduleType: "Standbook",
        imgurl: require('../assets/images/quality/standbook.png'),
        icon: 'icon-zhiliangtaizhang',
        path: '/quality/standbook',
        name: '质量台账',
        sort: 1
    },
        //     {
        //     moduleType: "Archives",
        //     imgurl: require('../assets/images/quality/archives.png'),
        //     icon: 'icon-zhiliangtaidangan',
        //     path: '/quality/archives',
        //     name: '质量档案',
        //     sort: 1
        // },
        {
            moduleType: "Testitems",
            imgurl: require('../assets/images/quality/testitems.png'),
            icon: 'icon-zhijianxiangmuguanli',
            path: '/quality/testitems',
            name: '质检项目管理',
            sort: 1,
            children: [{
                moduleType: "TestitemsItems",
                path: '/quality/testitems/items',
                name: '质检项',
                sort: 1,
            }, {
                moduleType: "TestitemsTemp",
                path: '/quality/testitems/temp',
                name: '质检模板',
                sort: 1,
            }, {
                moduleType: "TestitemsTempdetail",
                path: '/quality/testitems/tempdetail',
                name: '质检模板明细',
                sort: 1,
            }
                // , {
                //     moduleType: "TestitemsIncrease",
                //     path: '/quality/testitems/increase',
                //     name: '质检项增扣重标准',
                //     sort: 1,
                // }, {
                //     moduleType: "TestitemsDetail",
                //     path: '/quality/testitems/detail',
                //     name: '质检项增扣重标准明细',
                //     sort: 1,
                // }
            ]
        },
        {
            moduleType: "Qualityfile",
            path: '/quality/qualityfile',
            name: '质量档案',
            sort: 1
        },]
}

if (Config.hardwareSwitch) {
    NavConfig['EstorageNav'] = [{
        moduleType: "Warehousein",
        imgurl: require('../assets/images/estorage/warehousein.png'),
        icon: 'icon-ruku',
        path: '/estorage/warehousein/warehousein',
        roleId: ['crk', 'admin'],
        name: '入库作业',
        sort: 1,
        children: [{
            moduleType: "WarehouseinInstore",
            path: '/estorage/warehousein/instore',
            name: '入门登记',
            roleId: ['crk-rmdj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinAssay",
            path: '/estorage/warehousein/assay',
            name: '检验管理',
            roleId: ['crk-lszj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinGrossweight",
            path: '/estorage/warehousein/grossweight',
            name: '毛重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinTask",
            path: '/estorage/warehousein/task',
            name: '值仓管理',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinTotalskin",
            path: '/estorage/warehousein/totalskin',
            name: '皮重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinSettlement",
            path: '/estorage/warehousein/settlement',
            name: '结算',
            roleId: ['crk-js', 'admin'],
            sort: 1,
        },{
		    moduleType: "WarehouseinOutbound",
		    path: '/estorage/warehousein/outbound',
		    name: '出门登记',
		    roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessRegistration",
		    path: '/statistics/business/Registration',
		    name: '登记列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
 
    ]
    }, {
        moduleType: "Warehouseout",
        imgurl: require('../assets/images/estorage/warehouseout.png'),
        icon: 'icon-chuku',
        path: '/estorage/warehouseout',
        name: '出库作业',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "WarehouseoutOutstore",
            path: '/estorage/warehouseout/outstore',
            name: '入门登记',
            roleId: ['crk-rmdj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutTotalskin",
            path: '/estorage/warehouseout/totalskin',
            name: '皮重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutTask",
            path: '/estorage/warehouseout/task',
            name: '值仓管理',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutGrossweight",
            path: '/estorage/warehouseout/grossweight',
            name: '毛重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        },
		{
		    moduleType: "WarehouseoutOutbound",
		    path: '/estorage/warehouseout/outbound',
		    name: '出门登记',
		    roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
            // {
            //     moduleType: "WarehouseoutSettlement",
            //     path: '/estorage/warehouseout/settlement',
            //     name: '结算',
            // roleId: ['crk-js','admin'],
            //     sort: 1,
            // }
        ]
    }, {
        moduleType: "Append",
        imgurl: require('../assets/images/estorage/addrecord.png'),
        icon: 'icon-bulu',
        path: '/estorage/append',
        name: '补录',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "AppendWarehousein",
            path: '/estorage/append/warehousein',
            name: '入库补录',
            roleId: ['crk', 'admin'],
            sort: 1,
        }, {
            moduleType: "AppendWarehouseout",
            path: '/estorage/append/warehouseout',
            name: '出库补录',
            roleId: ['crk', 'admin'],
            sort: 1,
        },{
            moduleType: "AppendOutexamine",
            path: '/estorage/append/outexamine',
            name: '补录列表',
            sort: 1,
        }]
    }]
} else if (!Config.hardwareSwitch && (Config.depotIndex === 3||Config.depotIndex === 10||Config.depotIndex === 11)) {
    NavConfig['EstorageNav'] = [{
        moduleType: "Warehousein",
        imgurl: require('../assets/images/estorage/warehousein.png'),
        icon: 'icon-ruku',
        path: '/estorage/warehousein/warehousein',
        roleId: ['crk', 'admin'],
        name: '入库作业',
        sort: 1,
        children: [{
            moduleType: "WarehouseinInstore",
            path: '/estorage/warehousein/instore',
            name: '入门登记',
            roleId: ['crk-rmdj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinAssay",
            path: '/estorage/warehousein/assay',
            name: '检验管理',
            roleId: ['crk-lszj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinGrossweight",
            path: '/estorage/warehousein/grossweight',
            name: '毛重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinTask",
            path: '/estorage/warehousein/task',
            name: '值仓管理',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinTotalskin",
            path: '/estorage/warehousein/totalskin',
            name: '皮重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinSettlement",
            path: '/estorage/warehousein/settlement',
            name: '结算管理',
            roleId: ['crk-js', 'admin'],
            sort: 1,
        },{
		    moduleType: "WarehouseinOutbound",
		    path: '/estorage/warehousein/outbound',
		    name: '出门登记',
		    roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessRegistration",
		    path: '/statistics/business/Registration',
		    name: '登记列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessAssay",
		    path: '/statistics/business/Assay',
		    name: '检验列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessWeight",
		    path: '/statistics/business/Weight',
		    name: '称重列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessSettlement",
		    path: '/statistics/business/Settlement',
		    name: '结算列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessBack",
		    path: '/statistics/business/Back',
		    name: '退车列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
    ]
    }, {
        moduleType: "Warehouseout",
        imgurl: require('../assets/images/estorage/warehouseout.png'),
        icon: 'icon-chuku',
        path: '/estorage/warehouseout',
        name: '出库作业',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "WarehouseoutOutstore",
            path: '/estorage/warehouseout/outstore',
            name: '入门登记',
            roleId: ['crk-rmdj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutTotalskin",
            path: '/estorage/warehouseout/totalskin',
            name: '皮重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutTask",
            path: '/estorage/warehouseout/task',
            name: '值仓管理',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutGrossweight",
            path: '/estorage/warehouseout/grossweight',
            name: '毛重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        },
		{
		    moduleType: "WarehouseoutOutbound",
		    path: '/estorage/warehouseout/outbound',
		    name: '出门登记',
		    roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "WarehouseoutBusinessRegistration",
		    path: '/estorage/warehouseout/business/Registration',
		    name: '登记列表',
		    sort: 1,
		},
        {
		    moduleType: "WarehouseoutBusinessBack",
		    path: '/estorage/warehouseout/business/Back',
		    name: '退车列表',
		    sort: 1,
		},
        {
		    moduleType: "WarehouseoutBusinessWeight",
		    path: '/estorage/warehouseout/business/Weight',
		    name: '称重列表',
		    sort: 1,
		},
        // import WarehouseoutBusinessRegistration from "@/views/estorage/warehouseout/business/Registration.vue";
            // {
            //     moduleType: "WarehouseoutSettlement",
            //     path: '/estorage/warehouseout/settlement',
            //     name: '结算',
            // roleId: ['crk-js','admin'],
            //     sort: 1,
            // }
        ]
    }, {
        moduleType: "Warehousemove",
        imgurl: require('../assets/images/estorage/warehousemove.png'),
        icon: 'icon-yiku',
        path: '/estorage/warehousemove',
        name: '移库作业',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "WarehousemoveShiftin",
            path: '/estorage/warehousemove/shiftin',
            name: '移入作业',
            roleId: ['crk', 'admin'],
            sort: 1,
            children: [{
                moduleType: "WarehousemoveShiftinInstore",
                path: '/estorage/warehousemove/shiftin/instore',
                name: '入门登记',
                roleId: ['crk-rmdj', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinAssay",
                path: '/estorage/warehousemove/shiftin/assay',
                name: '检验管理',
                roleId: ['crk-lszj', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinGrossweight",
                path: '/estorage/warehousemove/shiftin/grossweight',
                name: '毛重称重',
                roleId: ['crk-gbcz', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinTask",
                path: '/estorage/warehousemove/shiftin/task',
                name: '值仓管理',
                roleId: ['crk-xczc', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinTotalskin",
                path: '/estorage/warehousemove/shiftin/totalskin',
                name: '皮重称重',
                roleId: ['crk-gbcz', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinSettlement",
                path: '/estorage/warehousemove/shiftin/settlement',
                name: '结算',
                roleId: ['crk-js', 'admin'],
                sort: 1,
            }]
        }, {
            moduleType: "WarehousemoveShiftout",
            path: '/estorage/warehousemove/shiftout',
            name: '移出作业',
            roleId: ['crk', 'admin'],
            sort: 1,
            children: [{
                moduleType: "WarehousemoveShiftoutOutstore",
                path: '/estorage/warehousemove/shiftout/outstore',
                name: '入门登记',
                roleId: ['crk-rmdj', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftoutTotalskin",
                path: '/estorage/warehousemove/shiftout/totalskin',
                name: '皮重称重',
                roleId: ['crk-gbcz', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftoutTask",
                path: '/estorage/warehousemove/shiftout/task',
                name: '值仓管理',
                roleId: ['crk-xczc', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftoutGrossweight",
                path: '/estorage/warehousemove/shiftout/grossweight',
                name: '毛重称重',
                roleId: ['crk-gbcz', 'admin'],
                sort: 1,
            }]
        }]
    }, {
        moduleType: "Warehousex",
        imgurl: require('../assets/images/estorage/warehousex.png'),
        icon: 'icon-daocang',
        path: '/estorage/warehousereplace',
        name: '倒仓作业',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "WarehousereplaceRegister",
            path: '/estorage/warehousereplace/register',
            name: '倒仓登记',
            roleId: ['crk-rmdj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehousereplaceTask",
            path: '/estorage/warehousereplace/task',
            name: '第一次值仓',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehousereplaceGrossweight",
            path: '/estorage/warehousereplace/grossweight',
            name: '毛重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehousereplaceTasksecond",
            path: '/estorage/warehousereplace/tasksecond',
            name: '第二次值仓',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehousereplaceTotalskin",
            path: '/estorage/warehousereplace/totalskin',
            name: '皮重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        },{
            moduleType: "BusinessDumped",
            path: '/statistics/business/dumped',
            name: '倒仓记录',
            // roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }

    
    
    ]
    }, {
        moduleType: "Append",
        imgurl: require('../assets/images/estorage/addrecord.png'),
        icon: 'icon-bulu',
        path: '/estorage/append',
        name: '补录',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "AppendWarehousein",
            path: '/estorage/append/warehousein',
            name: '入库补录',
            roleId: ['crk', 'admin'],
            sort: 1,
        }, {
            moduleType: "AppendWarehouseout",
            path: '/estorage/append/warehouseout',
            name: '出库补录',
            roleId: ['crk', 'admin'],
            sort: 1,
        },{
            moduleType: "AppendOutexamine",
            path: '/estorage/append/outexamine',
            name: '补录列表',
            sort: 1,
        }]
    }]
    NavConfig['SuperviseNav'] = [{
        moduleType: "Libcockpit",
        imgurl: require('../assets/images/supervise/libcockpit.png'),
        icon: 'icon-jichuxinxiguanli',
        path: '/supervise/libcockpit',
        name: '首页',
        sort: 1,
    },
        {
            moduleType: "Tandh",
            path: '/supervise/tandh',
            imgurl: require('../assets/images/supervise/tandh.png'),
            icon: 'icon-liangqingjiancha',
            name: '粮温粮湿监测',
            sort: 1,
            children: [{
                moduleType: "TandhStorehouse",
                path: '/supervise/tandh/storehouse',
                name: '老库仓房数据',
                sort: 1,
            },{
                moduleType: "WarnHumidity",
                path: '/supervise/warn/humidity',
                name: '温度告警信息',
                sort: 1,
            }, {
                moduleType: "WarnPest",
                path: '/supervise/warn/pest',
                name: '湿度告警信息',
                sort: 1,
            }, {
                moduleType: "TandhTemperature",
                path: '/supervise/tandh/temperature',
                name: '温湿度实时检测',
                sort: 1,
            }, {
                moduleType: "WarnReports",
                path: '/supervise/warn/reports',
                name: '温湿度监测记录报告',
                sort: 1,
            },{
                moduleType: "TandhStatistics",
                path: '/supervise/tandh/statistics',
                name: '温湿度统计报表',
                sort: 1,
            }, {
                moduleType: "TandhChart",
                path: '/supervise/tandh/chart',
                name: '温湿度分析图表',
                sort: 1,
            }]
        }
        , {
            moduleType: "Gas",
            imgurl: require('../assets/images/supervise/gas.png'),
            icon: 'icon-qitijiance',
            path: '/supervise/gas',
            name: '气体检测',
            sort: 1,
            children: [{
                moduleType: "WarnGas",
                path: '/supervise/warn/gas',
                name: '气体告警信息',
                sort: 1,
            }, {
                moduleType: "GasRealtime",
                path: '/supervise/gas/realtime',
                name: '气体实时检测',
                sort: 1,
            }, {
                moduleType: "GasStatistics",
                path: '/supervise/gas/statistics',
                name: '气体统计报表',
                sort: 1,
            },
                // {
                //     moduleType: "GasChart",
                //     path: '/supervise/gas/chart',
                //     name: '气体分析图表',
                //     sort: 1,
                // }
            ]
        }
        , {
            moduleType: "Window",
            imgurl: require('../assets/images/supervise/window.png'),
            icon: 'icon-chuanghujiance',
            path: '/supervise/window',
            name: '窗户检测',
            sort: 1,
            children: [{
                moduleType: "WindowState",
                path: '/supervise/window/state',
                name: '窗户状态检测',
                sort: 1,
            }]
        }
        , {
            moduleType: "Health",
            imgurl: require('../assets/images/supervise/health.png'),
            icon: 'icon-liangshijiankangzhishu',
            path: '/supervise/health',
            name: '粮食健康',
            sort: 1,
            children: [{
                moduleType: "HealthSummary",
                path: '/supervise/health/summary',
                name: '健康总览',
                sort: 1,
            }, {
                moduleType: "WarnHealth",
                path: '/supervise/warn/health',
                name: '仓房健康情况',
                sort: 1,
            },]
        },{
            moduleType: "Quantity",
            path: '/supervise/quantity',
            name: '数量监测',
            children: [{
                moduleType: "QuantityWarehouse003",
                path: '/supervise/quantity/warehouse003',
                name: '数量监测',
                sort: 1,
            },]
        }]
    NavConfig['SecurityNav'] = [{
        moduleType: "Surveyhome",
        imgurl: require('../assets/images/security/surveyhome.png'),
        icon: 'icon-shouye',
        path: '/security/surveyhome',
        name: '首页',
        sort: 1,
    }, {
        moduleType: "Video",
        imgurl: require('../assets/images/security/video.png'),
        icon: 'icon-shipinjiankong',
        path: '/security/video',
        name: '视频监控',
        sort: 1,
        children: [{
            moduleType: "VideoSynthetical",
            path: '/security/video/synthetical',
            name: '综合安防',
            sort: 1,
        }, {
            moduleType: "VideoList",
            path: '/security/video/list',
            name: '监控列表',
            sort: 1,
        }, {
            moduleType: "VideoRecording",
            path: '/security/video/recording',
            name: '监控录像',
            sort: 1,
        }, {
            moduleType: "VideoCameras",
            path: '/security/video/cameras',
            name: '监控管理',
            sort: 1,
        }]
    }, {
        moduleType: "Aivideo",
        imgurl: require('../assets/images/security/aivideo.png'),
        icon: 'icon-AIjianguan',
        path: '/security/aivideo',
        name: 'AI监管',
        sort: 1,
        children: [{
            moduleType: "AivideoPerson",
            path: '/security/aivideo/person',
            name: '人员监管',
            sort: 1,
        }, {
            moduleType: "AivideoGrain",
            path: '/security/aivideo/grain',
            name: '粮食监管',
            sort: 1,
        }
            // , {
            //     moduleType: "AivideoArea",
            //     path: '/security/aivideo/area',
            //     name: '库区监管',
            //     sort: 1,
            // }
        ]
    },
        // {
        //     moduleType: "Risk",
        //     imgurl: require('../assets/images/security/risk.png'),
        //     path: '/security/risk',
        //     name: '风险提示',
        //     sort: 1
        // }
    ]
} else if (!Config.hardwareSwitch && Config.depotIndex !== 3&& Config.depotIndex !== 10&& Config.depotIndex !== 11) {
    NavConfig['EstorageNav'] = [{
        moduleType: "Warehousein",
        imgurl: require('../assets/images/estorage/warehousein.png'),
        icon: 'icon-ruku',
        path: '/estorage/warehousein/warehousein',
        roleId: ['crk', 'admin'],
        name: '入库作业',
        sort: 1,
        children: [{
            moduleType: "WarehouseinInstore",
            path: '/estorage/warehousein/instore',
            name: '入门登记',
            roleId: ['crk-rmdj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinAssay",
            path: '/estorage/warehousein/assay',
            name: '检验管理',
            roleId: ['crk-lszj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinGrossweight",
            path: '/estorage/warehousein/grossweight',
            name: '毛重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinTask",
            path: '/estorage/warehousein/task',
            name: '值仓管理',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinTotalskin",
            path: '/estorage/warehousein/totalskin',
            name: '皮重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseinSettlement",
            path: '/estorage/warehousein/settlement',
            name: '结算管理',
            roleId: ['crk-js', 'admin'],
            sort: 1,
        },
        {
		    moduleType: "WarehouseinOutbound",
		    path: '/estorage/warehousein/outbound',
		    name: '出门登记',
		    roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessRegistration",
		    path: '/statistics/business/Registration',
		    name: '登记列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessAssay",
		    path: '/statistics/business/Assay',
		    name: '检验列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessWeight",
		    path: '/statistics/business/Weight',
		    name: '称重列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessSettlement",
		    path: '/statistics/business/Settlement',
		    name: '结算列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
        {
		    moduleType: "BusinessBack",
		    path: '/statistics/business/Back',
		    name: '退车列表',
		    // roleId: ['crk-cmdj', 'admin'],
		    sort: 1,
		},
    ]
    }, {
        moduleType: "Warehouseout",
        imgurl: require('../assets/images/estorage/warehouseout.png'),
        icon: 'icon-chuku',
        path: '/estorage/warehouseout',
        name: '出库作业',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "WarehouseoutOutstore",
            path: '/estorage/warehouseout/outstore',
            name: '入门登记',
            roleId: ['crk-rmdj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutTotalskin",
            path: '/estorage/warehouseout/totalskin',
            name: '皮重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutTask",
            path: '/estorage/warehouseout/task',
            name: '值仓管理',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehouseoutGrossweight",
            path: '/estorage/warehouseout/grossweight',
            name: '毛重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        },
        {
		    moduleType: "WarehouseoutBusinessRegistration",
		    path: '/estorage/warehouseout/business/Registration',
		    name: '登记列表',
		    sort: 1,
		},
        {
		    moduleType: "WarehouseoutBusinessBack",
		    path: '/estorage/warehouseout/business/Back',
		    name: '退车列表',
		    sort: 1,
		},
        {
		    moduleType: "WarehouseoutBusinessWeight",
		    path: '/estorage/warehouseout/business/Weight',
		    name: '称重列表',
		    sort: 1,
		},
            // {
            //     moduleType: "WarehouseoutSettlement",
            //     path: '/estorage/warehouseout/settlement',
            //     name: '结算',
            // roleId: ['crk-js','admin'],
            //     sort: 1,
            // }
        ]
    }, {
        moduleType: "Warehousemove",
        imgurl: require('../assets/images/estorage/warehousemove.png'),
        icon: 'icon-yiku',
        path: '/estorage/warehousemove',
        name: '移库作业',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "WarehousemoveShiftin",
            path: '/estorage/warehousemove/shiftin',
            name: '移入作业',
            roleId: ['crk', 'admin'],
            sort: 1,
            children: [{
                moduleType: "WarehousemoveShiftinInstore",
                path: '/estorage/warehousemove/shiftin/instore',
                name: '入门登记',
                roleId: ['crk-rmdj', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinAssay",
                path: '/estorage/warehousemove/shiftin/assay',
                name: '检验管理',
                roleId: ['crk-lszj', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinGrossweight",
                path: '/estorage/warehousemove/shiftin/grossweight',
                name: '毛重称重',
                roleId: ['crk-gbcz', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinTask",
                path: '/estorage/warehousemove/shiftin/task',
                name: '值仓管理',
                roleId: ['crk-xczc', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinTotalskin",
                path: '/estorage/warehousemove/shiftin/totalskin',
                name: '皮重称重',
                roleId: ['crk-gbcz', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftinSettlement",
                path: '/estorage/warehousemove/shiftin/settlement',
                name: '结算',
                roleId: ['crk-js', 'admin'],
                sort: 1,
            }]
        }, {
            moduleType: "WarehousemoveShiftout",
            path: '/estorage/warehousemove/shiftout',
            name: '移出作业',
            roleId: ['crk', 'admin'],
            sort: 1,
            children: [{
                moduleType: "WarehousemoveShiftoutOutstore",
                path: '/estorage/warehousemove/shiftout/outstore',
                name: '入门登记',
                roleId: ['crk-rmdj', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftoutTotalskin",
                path: '/estorage/warehousemove/shiftout/totalskin',
                name: '皮重称重',
                roleId: ['crk-gbcz', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftoutTask",
                path: '/estorage/warehousemove/shiftout/task',
                name: '值仓管理',
                roleId: ['crk-xczc', 'admin'],
                sort: 1,
            }, {
                moduleType: "WarehousemoveShiftoutGrossweight",
                path: '/estorage/warehousemove/shiftout/grossweight',
                name: '毛重称重',
                roleId: ['crk-gbcz', 'admin'],
                sort: 1,
            }]
        }]
    }, {
        moduleType: "Warehousex",
        imgurl: require('../assets/images/estorage/warehousex.png'),
        icon: 'icon-daocang',
        path: '/estorage/warehousereplace',
        name: '倒仓作业',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "WarehousereplaceRegister",
            path: '/estorage/warehousereplace/register',
            name: '倒仓登记',
            roleId: ['crk-rmdj', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehousereplaceTask",
            path: '/estorage/warehousereplace/task',
            name: '第一次值仓',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehousereplaceGrossweight",
            path: '/estorage/warehousereplace/grossweight',
            name: '毛重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehousereplaceTasksecond",
            path: '/estorage/warehousereplace/tasksecond',
            name: '第二次值仓',
            roleId: ['crk-xczc', 'admin'],
            sort: 1,
        }, {
            moduleType: "WarehousereplaceTotalskin",
            path: '/estorage/warehousereplace/totalskin',
            name: '皮重称重',
            roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        },{
            moduleType: "BusinessDumped",
            path: '/statistics/business/dumped',
            name: '倒仓记录',
            // roleId: ['crk-gbcz', 'admin'],
            sort: 1,
        }]
    }, {
        moduleType: "Append",
        imgurl: require('../assets/images/estorage/addrecord.png'),
        icon: 'icon-bulu',
        path: '/estorage/append',
        name: '补录',
        roleId: ['crk', 'admin'],
        sort: 1,
        children: [{
            moduleType: "AppendWarehousein",
            path: '/estorage/append/warehousein',
            name: '入库补录',
            roleId: ['crk', 'admin'],
            sort: 1,
        }, {
            moduleType: "AppendWarehouseout",
            path: '/estorage/append/warehouseout',
            name: '出库补录',
            roleId: ['crk', 'admin'],
            sort: 1,
        },{
            moduleType: "AppendOutexamine",
            path: '/estorage/append/outexamine',
            name: '补录列表',
            sort: 1,
        }]
    }]
    NavConfig['SuperviseNav'] = [{
        moduleType: "Libcockpit",
        imgurl: require('../assets/images/supervise/libcockpit.png'),
        icon: 'icon-jichuxinxiguanli',
        path: '/supervise/libcockpit',
        name: '首页',
        sort: 1,
    },
        {
            moduleType: "Tandh",
            path: '/supervise/tandh',
            imgurl: require('../assets/images/supervise/tandh.png'),
            icon: 'icon-liangqingjiancha',
            name: '粮温粮湿监测',
            sort: 1,
            children: [{
                moduleType: "WarnHumidity",
                path: '/supervise/warn/humidity',
                name: '温度告警信息',
                sort: 1,
            }, {
                moduleType: "WarnPest",
                path: '/supervise/warn/pest',
                name: '湿度告警信息',
                sort: 1,
            }, {
                moduleType: "TandhTemperature",
                path: '/supervise/tandh/temperature',
                name: '温湿度实时检测',
                sort: 1,
            }, {
                moduleType: "WarnReports",
                path: '/supervise/warn/reports',
                name: '温湿度监测记录报告',
                sort: 1,
            },{
                moduleType: "TandhStatistics",
                path: '/supervise/tandh/statistics',
                name: '温湿度统计报表',
                sort: 1,
            }, {
                moduleType: "TandhChart",
                path: '/supervise/tandh/chart',
                name: '温湿度分析图表',
                sort: 1,
            }]
        }
        // , {
        //     moduleType: "Gas",
        //     imgurl: require('../assets/images/supervise/gas.png'),
        //     icon: 'icon-qitijiance',
        //     path: '/supervise/gas',
        //     name: '气体检测',
        //     sort: 1,
        //     children: [{
        //         moduleType: "WarnGas",
        //         path: '/supervise/warn/gas',
        //         name: '气体告警信息',
        //         sort: 1,
        //     }, {
        //         moduleType: "GasRealtime",
        //         path: '/supervise/gas/realtime',
        //         name: '气体实时检测',
        //         sort: 1,
        //     }, {
        //         moduleType: "GasStatistics",
        //         path: '/supervise/gas/statistics',
        //         name: '气体统计报表',
        //         sort: 1,
        //     },
                // {
                //     moduleType: "GasChart",
                //     path: '/supervise/gas/chart',
                //     name: '气体分析图表',
                //     sort: 1,
                // }
            // ]
        // }
        // , {
        //     moduleType: "Window",
        //     imgurl: require('../assets/images/supervise/window.png'),
        //     icon: 'icon-chuanghujiance',
        //     path: '/supervise/window',
        //     name: '窗户检测',
        //     sort: 1,
        //     children: [{
        //         moduleType: "WindowState",
        //         path: '/supervise/window/state',
        //         name: '窗户状态检测',
        //         sort: 1,
        //     }]
        // }
        , {
            moduleType: "Health",
            imgurl: require('../assets/images/supervise/health.png'),
            icon: 'icon-liangshijiankangzhishu',
            path: '/supervise/health',
            name: '粮食健康',
            sort: 1,
            children: [{
                moduleType: "HealthSummary",
                path: '/supervise/health/summary',
                name: '健康总览',
                sort: 1,
            }, {
                moduleType: "WarnHealth",
                path: '/supervise/warn/health',
                name: '仓房健康情况',
                sort: 1,
            },]
        }]
    NavConfig['SecurityNav'] = [
        //     {
        //     moduleType: "Surveyhome",
        //     imgurl: require('../assets/images/security/surveyhome.png'),
        //     icon: 'icon-shouye',
        //     path: '/security/surveyhome',
        //     name: '首页',
        //     sort: 1,
        // },
        {
            moduleType: "Video",
            imgurl: require('../assets/images/security/video.png'),
            icon: 'icon-shipinjiankong',
            path: '/security/video',
            name: '视频监控',
            sort: 1,
            children: [{
                moduleType: "VideoSynthetical",
                path: '/security/video/synthetical',
                name: '综合安防',
                sort: 1,
            }, {
                moduleType: "VideoList",
                path: '/security/video/list',
                name: '监控列表',
                sort: 1,
            }, {
                moduleType: "VideoRecording",
                path: '/security/video/recording',
                name: '监控录像',
                sort: 1,
            }, {
                moduleType: "VideoCameras",
                path: '/security/video/cameras',
                name: '监控管理',
                sort: 1,
            }]
        },
        // {
        // moduleType: "Aivideo",
        // imgurl: require('../assets/images/security/aivideo.png'),
        // icon: 'icon-AIjianguan',
        // path: '/security/aivideo',
        // name: 'AI监管',
        // sort: 1,
        // children: [{
        //     moduleType: "AivideoPerson",
        //     path: '/security/aivideo/person',
        //     name: '人员监管',
        //     sort: 1,
        // }, {
        //     moduleType: "AivideoGrain",
        //     path: '/security/aivideo/grain',
        //     name: '粮食监管',
        //     sort: 1,
        // }
        // , {
        //     moduleType: "AivideoArea",
        //     path: '/security/aivideo/area',
        //     name: '库区监管',
        //     sort: 1,
        // }
        // ]
        // },
        // {
        //     moduleType: "Risk",
        //     imgurl: require('../assets/images/security/risk.png'),
        //     path: '/security/risk',
        //     name: '风险提示',
        //     sort: 1
        // }
    ]
}
if(NavConfig['EstorageNav']){
    NavConfig['EstorageNav'].unshift({
        moduleType: "Notices",
        path: '/security/video',
        name: '出入库计划',
        sort: 1,
        children: [{
            moduleType: "NoticesInstore",
            path: '/manage/notices/instore',
            name: '入库单',
            sort: 1,
        }, {
            moduleType: "NoticesOutstore",
            path: '/manage/notices/outstore',
            name: '提货单',
            sort: 1,
        }, {
            moduleType: "NoticesMovestore",
            path: '/manage/notices/movestore',
            name: '移货申请单',
            sort: 1,
        }, {
            moduleType: "ShiftReplace",
            path: '/manage/shift/replace',
            name: '倒仓记录',
            sort: 1,
        }, {
            moduleType: "BasicsContract",
            path: '/manage/basics/contract',
            name: '合同管理',
            sort: 1,
        },{
            moduleType: "BasicsCustomer",
            path: '/manage/basics/customer',
            name: '客户管理',
            sort: 2,
        },
    ]
    },)
}
export default NavConfig
